__turbopack_context__.v({
  "bannerButton": "styles-module__J_ojDG__bannerButton",
  "bannerImage": "styles-module__J_ojDG__bannerImage",
  "bodyParagraph": "styles-module__J_ojDG__bodyParagraph",
  "container": "styles-module__J_ojDG__container",
  "contentWrapper": "styles-module__J_ojDG__contentWrapper",
  "ctaWrapper": "styles-module__J_ojDG__ctaWrapper",
  "heading": "styles-module__J_ojDG__heading",
  "sand": "styles-module__J_ojDG__sand",
});
